var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('div',{staticClass:"text-center"},[_c('br'),_c('br'),_c('strong',[_vm._v("AMIA Baseline Survey is under construction. ")]),_c('br'),_vm._v(" Please contact the admin for more info. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }